import React from 'react';
import { BROKER_BRAND, resolveBrokerKey } from './brokerBranding';
import AccountSmartTiles from './AccountSmartTiles';
import AccountPeriodStats from './AccountPeriodStats';
import ClientReportingChartPanel from './ClientReportingChartPanel';
import ClientReportingDateRangeControls from './ClientReportingDateRangeControls';
import TradeHistory from './TradeHistory';
import ClientReportingTradeCalendar from './ClientReportingTradeCalendar';
import { brokerAccountDisplayName } from './clientReportingUtils';
import ClientReportingPortfolioSwitcher from './ClientReportingPortfolioSwitcher';
import { IconChevronLeft } from '../Icons';

function AccountBadge({ client }) {
  const key = resolveBrokerKey(client.name, client.broker);
  const brand = key ? BROKER_BRAND[key] : null;
  if (brand?.logoSrc) {
    return (
      <span className={`vd-broker-logo ${brand.tone} has-image`} aria-hidden="true">
        <img src={brand.logoSrc} alt="" />
      </span>
    );
  }
  return (
    <span className="vd-broker-logo" aria-hidden="true">
      {brand?.shortName || (client.broker || '?').slice(0, 2).toUpperCase()}
    </span>
  );
}

export default function ClientReportingPortfolioDetail({
  client,
  clients,
  onBack,
  onSelectClient = null,
  effectiveRange,
  chartProps,
  refreshKey = 0,
}) {
  if (!client) return null;

  const displayName = brokerAccountDisplayName(client);
  const {
    dateRange,
    onDateRangeChange,
    customDateRange,
    onCustomDateRangeChange,
  } = chartProps;

  return (
    <div className="vd-ml-detail-view">
      <div className="vd-ml-detail-header">
        <div className="vd-ml-detail-heading">
          <button type="button" className="vd-ml-back-btn" onClick={onBack}>
            <IconChevronLeft size={16} />
            Portfolios
          </button>
          <div className="vd-ml-detail-title-bar">
            <div className="vd-ml-detail-title-row">
              <AccountBadge client={client} />
              <div>
                {/* The title doubles as the portfolio switcher — it already
                    names the current account, so it is where you look when you
                    want a different one. */}
                <ClientReportingPortfolioSwitcher
                  client={client}
                  clients={clients || []}
                  onSelect={onSelectClient}
                  title={displayName}
                />
                <p className="vd-ml-detail-subtitle">{client.name}</p>
              </div>
            </div>
            <ClientReportingDateRangeControls
              dateRange={dateRange}
              onDateRangeChange={onDateRangeChange}
              customDateRange={customDateRange}
              onCustomDateRangeChange={onCustomDateRangeChange}
              className="vd-ml-detail-header-date-range"
            />
          </div>
        </div>
      </div>

      <AccountSmartTiles
        dataSeriesName={client.dataSeriesName}
        dateRange={effectiveRange}
      />

      <ClientReportingChartPanel
        {...chartProps}
        compact
      />

      <AccountPeriodStats
        dataSeriesName={client.dataSeriesName}
        className="vd-ml-detail-period-stats"
      />

      {/* Same placement as the dashboard: above the trade list, so the month
          grid says which days did it before the rows say how. Pinned to this
          one account rather than the dashboard's selection. */}
      <ClientReportingTradeCalendar
        clients={clients}
        selectedClientId={client.id}
        refreshKey={refreshKey}
      />

      <TradeHistory
        clients={clients}
        defaultClientId={client.id}
        dateRange={effectiveRange}
        compact
        refreshKey={refreshKey}
      />
    </div>
  );
}
